import { render, staticRenderFns } from "./ClientUserTable.vue?vue&type=template&id=f770e3d6&scoped=true&"
import script from "./ClientUserTable.vue?vue&type=script&lang=js&"
export * from "./ClientUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f770e3d6",
  null
  
)

export default component.exports